export default __webpack_public_path__ + "static/media/CDR LOGO_NEGRO.c7013b92.png";